import React from "react";
import "./skeleton.css";

/**
 * SkeletonListItem — Skeleton for the Historique page's horizontal card layout.
 * Mirrors the Card > CardContent > flex layout with thumbnail + text block.
 *
 * @param {Object} props
 * @param {number} [props.index=0] - Index for stagger animation delay
 */
export default function SkeletonListItem({ index = 0 }) {
    const staggerClass = `skeleton-stagger-${Math.min(index + 1, 10)}`;

    return (
        <div className="skeleton-list-item" role="presentation">
            {/* Thumbnail square */}
            <div
                className={`skeleton-bone skeleton-rounded-lg skeleton-list-thumb ${staggerClass}`}
            />
            {/* Text content */}
            <div className="skeleton-list-body">
                <div>
                    <div className={`skeleton-bone skeleton-list-title ${staggerClass}`} />
                    <div
                        className={`skeleton-bone skeleton-list-brand ${staggerClass}`}
                        style={{ marginTop: "0.375rem" }}
                    />
                </div>
                <div className={`skeleton-bone skeleton-rounded-full skeleton-list-badge ${staggerClass}`} />
                <div className={`skeleton-bone skeleton-list-date ${staggerClass}`} />
            </div>
        </div>
    );
}
